import { AcceptedCurrency } from 'src/types/trip';

export type FlashPackLocale = {
  country: string;
  currencyCode: AcceptedCurrency;
};

// TODO duplicated from global.d.ts
declare global {
  interface Window {
    getCookieInline(name: string): string | null;
  }
}

export function getCurrentLocale(): FlashPackLocale {
  const countryCookie = window.getCookieInline?.('country');
  const currencyCookie: AcceptedCurrency = window.getCookieInline?.(
    'currency',
  ) as AcceptedCurrency;

  if (countryCookie && currencyCookie) {
    return {
      country: countryCookie,
      currencyCode: currencyCookie,
    };
  }

  const browserLocale = navigator.language;
  if (browserLocale) {
    return {
      country: browserLocale.split('-')[0],
      currencyCode: 'usd', // todo: maybe map country to a currency code?
    };
  }

  return {
    country: 'us',
    currencyCode: 'usd',
  };
}
